import { Box } from "@mui/material";
import styles from "./style.module.css";
import Card from "./card";
import LoadingButton from "../../../../../components/loading/button";
import ProjectCard from "./projectCard";
import { useSelector } from "react-redux";

const ListResult = () => {
  const { isLoading } = useSelector((state) => state.discover);
  const { data } = useSelector((state) => state.discover);

  return (
    <Box className={styles.result}>
      {data.map(
        (item, index) =>
          (item.key === "user" && <Card key={index} project={item} />) ||
          (item.key === "project" && <ProjectCard key={index} project={item} />)
      )}
      {isLoading && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LoadingButton />
        </Box>
      )}
    </Box>
  );
};

export default ListResult;
